import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router";
import { App } from "@/App";
import { ToastProvider } from "@/components/ui/Toast";
import { registerServiceWorker, setupInstallPrompt } from "@/lib/pwa";
import { installOnlineFlush } from "@/lib/offlineQueue";
import "@/styles/globals.css";

setupInstallPrompt();
registerServiceWorker();
installOnlineFlush();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
